import React from 'react';

export const iClassAsterix = fund =>
  Boolean(fund?.iClass && !fund.retirementDateFund);

// TODO [2020-05-25]: If we are still getting these from server talk to Don... otherwise remove this...
export const NA_VALUE = -2147483648;

export const normalizeValue = (value, isPercent) => {
  if (!value || value === NA_VALUE) {
    return '-';
  }

  const val = parseFloat(value);
  const newVal = Number.isNaN(val) ? '-' : val.toFixed(2);

  return isPercent ? `${newVal}%` : newVal;
};

export const withAnnotation = (growth = '-') => {
  const percentAsInt = parseInt(growth, 10);
  if (percentAsInt && percentAsInt >= 40) {
    return (
      <>
        {growth}
        <sup>†</sup>
      </>
    );
  }
  return <>{growth}</>;
};

export const cashLikeFunds = [
  'PCTXX',
  'PRWCX',
  'PRFDX',
  'RPGAX',
  'RPGIX',
  'PRGMX',
  'PRIPX',
  'RPIBX',
  'PRITX',
  'PRJPX',
  'TRBFX',
  'PRNEX',
  'TRPBX',
  'PRSIX',
  'TQGEX',
  'TQMVX',
  'TRRGX',
  'TRRJX',
  'TRRDX',
  'TRRKX',
  'TRRMX',
  'TRRNX',
  'TRRLX',
  'PRWBX',
  'PSILX',
  'PRSMX',
  'TRROX',
  'TRRVX',
  'TRFOX',
  'TRFFX',
  'TRTFX',
  'PRFSX',
  'POMIX',
  'TRBUX',
  'TCBXX',
  'TRAIX',
  'REIPX',
  'TGAFX',
  'TRGAX',
  'PRXAX',
  'TIIPX',
  'RPISX',
  'PRIUX',
  'RJAIX',
  'TRLDX',
  'TRNEX',
  'TPPAX',
  'PPIPX',
  'TQGIX',
  'TQVIX',
  'TRFGX',
  'TRPJX',
  'TRPDX',
  'TRPKX',
  'TRPMX',
  'TRPNX',
  'TRPLX',
  'TBSIX',
  'TORFX',
  'TRVVX',
  'TOORX',
  'TRPPX',
  'TTOIX',
  'TTSIX',
  'TRSTX'
];
